import React, { Fragment } from "react";
import { Card, CardBody, CardHeader, Col } from "reactstrap";
import { H3 } from "../../../AbstractElements";
import { enquiryDetails } from "../../../Constant";
import { Link } from "react-router-dom";
import { NewOrderSvg, PendingSvg } from "../../../Data/Widgets/General/Data";
import wonsvg from '../../../assets/images/Icons/Won.svg'
import convertsvg from '../../../assets/images/Icons/Converted.svg'
import "./DashboardStatCard.scss";


const EnquiryProfile = (props) => {
    const defaultSalesData = [
        {
            id: 1,
            link: `${process.env.PUBLIC_URL}/lead-manage/enquiry`,
            fallbackTitle: 'Today',
            tone: 'primary',
            icon: <NewOrderSvg />,
        },
        {
            id: 2,
            link: `${process.env.PUBLIC_URL}/lead-manage/leads`,
            fallbackTitle: 'Converted',
            tone: 'secondary',
            icon: <img src={convertsvg} alt="" />,
        },
        {
            id: 3,
            link: `${process.env.PUBLIC_URL}/lead-manage/leads?stage=won`,
            fallbackTitle: 'Won',
            tone: 'success',
            icon: <img src={wonsvg} alt="" />,
        },
        {
            id: 4,
            link: `${process.env.PUBLIC_URL}/lead-manage/overdue-follow-ups`,
            fallbackTitle: 'Overdues',
            tone: 'warning',
            icon: <PendingSvg />,
        },
    ];

    const value = props.details || [];
    // Won card also shows how many won leads were converted to customers
    const convertedCount =
        value[2]?.converted_count ??
        value.find((entry) => entry?.converted_count != null)?.converted_count ??
        0;

    const SalesData = defaultSalesData.map((item, index) => ({
        ...item,
        title: value[index]?.status || item.fallbackTitle,
        counter: value[index]?.count || 0,
    }));


    return (
        <Fragment>
            <Col xl="6" className="box-col-6">
                <Card className="dash-stats">
                    <CardHeader className="pb-0">
                        <H3>{enquiryDetails}</H3>
                    </CardHeader>

                    <CardBody>
                        <div className="dash-stats__grid">
                            {SalesData.map((data) => (
                                <Link
                                    key={data.id}
                                    to={data.link}
                                    className={`dash-stat dash-stat--${data.tone}`}
                                    aria-label={`${data.title}: ${data.counter}${data.id === 3 ? `, ${convertedCount} converted to customer` : ''}`}
                                >
                                    <div className="dash-stat__main">
                                        <span className="dash-stat__icon" aria-hidden="true">
                                            {data.icon}
                                        </span>
                                        <div className="dash-stat__body">
                                            <span className="dash-stat__label" title={data.title}>{data.title}</span>
                                            <span className="dash-stat__value">{data.counter}</span>
                                        </div>
                                    </div>
                                    {data.id === 3 && (
                                        <div className="dash-stat__meta">
                                            <span>Converted to Customer</span>
                                            <span className="dash-stat__meta-value">{convertedCount}</span>
                                        </div>
                                    )}
                                </Link>
                            ))}
                        </div>
                    </CardBody>
                </Card>
            </Col>
        </Fragment>
    );
};

export default EnquiryProfile;
